import React from "react";
import "../styles/Footer.css";
function Footer() {
  return (
    <div className="footer">
      <div className="copyright">Copyright &#169; TROUBLE FIXER</div>
    </div>
  );
}

export default Footer;
